import "./money-saving-tips.scss"

function moneySavingTips() {
  const textLink = document.querySelector("#title")
  const videoLink = document.querySelector("#url")
  const validationTitle = document.querySelector(".money-saving-tips__validiation--title")
  const validationUrl = document.querySelector(".money-saving-tips__validiation--url")

  if (!textLink || !videoLink) {
    return
  }

  function getInputTitle() {
    const titleInput = textLink.value
    document.querySelector(".money-saving-tips__iframe-header").innerHTML = titleInput

    if (titleInput.length > 5 && titleInput.length <= 40) {
      document.querySelector(".money_tips__button").classList.remove("money-saving-tips__hide")
      textLink.classList.remove("money-saving-tips__error")
      textLink.classList.add("money-saving-tips__valid")
      validationTitle.innerHTML = ""
      validationTitle.classList.remove("money-saving-tips__error--span")
    } else {
      document.querySelector(".money_tips__button").classList.add("money-saving-tips__hide")
      textLink.classList.remove("money-saving-tips__valid")
      textLink.classList.add("money-saving-tips__error")
      validationTitle.classList.add("money-saving-tips__error--span")

      if (titleInput.length < 5) {
        validationTitle.innerHTML = "Video title is too short, must be more than 5 characters"
      } else if (titleInput.length > 40) {
        validationTitle.innerHTML = "Video title is too long, must be less than 40 characters"
      } else {
        validationTitle.innerHTML = ""
      }
    }
  }

  function getInputValue() {
    const urlInput = videoLink.value
    document.querySelector("#iframe").src = urlInput

    const youtubeString = "https://www.youtube.com/embed/"
    if (!urlInput.includes(youtubeString)) {
      document.querySelector(".money_tips__button").classList.add("money-saving-tips__hide")
      videoLink.classList.remove("money-saving-tips__valid")
      videoLink.classList.add("money-saving-tips__error")
      validationUrl.classList.add("money-saving-tips__error--span")
      validationUrl.innerHTML = `Link must include: ${youtubeString}`
    } else {
      document.querySelector(".money_tips__button").classList.remove("money-saving-tips__hide")
      videoLink.classList.remove("money-saving-tips__error")
      validationUrl.classList.remove("money-saving-tips__error--span")
      videoLink.classList.add("money-saving-tips__valid")
      validationUrl.innerHTML = ""
    }
  }
  getInputTitle()
  getInputValue()
  textLink.addEventListener("input", getInputTitle)
  videoLink.addEventListener("input", getInputValue)
}

export default moneySavingTips
